import { DataEntityReferencePropertyPresenterModel } from './configuration-models';

export class DelegationPresenterModel {
  id: string;
  delegator: DataEntityReferencePropertyPresenterModel;
  fromDate: Date;
  toDate: Date;
}
